import intl from 'react-intl-universal';

export default class I18n {

    static getLangCode() {
        let langCode = "en-GB";

        let spa_lang_codes = ["es", "es-mx", "es-cl", "spa"];
        if (spa_lang_codes.indexOf(window.app.lang) !== -1) {
            langCode = "es-MX";
        }

        let zho_lang_codes = ["zh-cn", "zh", "zho"];
        if (zho_lang_codes.indexOf(window.app.lang) !== -1) {
            langCode = "zh-CN";
        }

        let zh_tw_lang_codes = ["zh-tw"];
        if (zh_tw_lang_codes.indexOf(window.app.lang) !== -1) {
            langCode = "zh-TW";
        }

        let vi_lang_codes = ["vi", "vie"];
        if (vi_lang_codes.indexOf(window.app.lang) !== -1) {
            langCode = "vi-VN";
        }

        let ko_lang_codes = ["ko", "ko-kr", "kor"];
        if (ko_lang_codes.indexOf(window.app.lang) !== -1) {
            langCode = "ko-KR";
        }

        let tl_lang_codes = ["tl", "fil"];
        if (tl_lang_codes.indexOf(window.app.lang) !== -1) {
            langCode = "tl-PH";
        }

        let fr_lang_codes = ["fr", "fr-ca", "fra"];
        if (fr_lang_codes.indexOf(window.app.lang) !== -1) {
            langCode = "fr-FR";
        }

        let pt_br_lang_codes = ["pt-BR", "pt", "por", "pt-br"];
        if (pt_br_lang_codes.indexOf(window.app.lang) !== -1) {
            langCode = "pt-BR";
        }

        let ar_br_lang_codes = ["ar", "ara"];
        if (ar_br_lang_codes.indexOf(window.app.lang) !== -1) {
            langCode = "ar-SA";
        }
        return langCode;
    }

    static dataTable() {
        let langCode = I18n.getLangCode();
        return require(`../locales/plugins/datatables/${langCode}.json`);
    }

    static vc() {
        let langCode = I18n.getLangCode();
        return require(`../locales/vc/${langCode}.json`);
    }

    // This is just to export the strings to translations
    terms() {
        return [
            intl.get("clinic").d("{num, plural, =0 {clinic} =1 {clinic} other {clinics}}"),
            intl.get("patient").d("{num, plural, =0 {patient} =1 {patient} other {patients}}"),
            intl.get("visit").d("visit"),
            intl.get("room").d("{num, plural, =0 {room} =1 {room} other {rooms}}"),
            intl.get("provider").d("{num, plural, =0 {provider} =1 {provider} other {providers}}"),
        ];
    }
}
